var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
let FiltersContainer = class FiltersContainer extends Vue {
    constructor() {
        super(...arguments);
        this.showFilters = false;
        this.userSearchTerm = '';
        this.statuses = [
            { isSelected: false, label: 'Ativo', value: 'active' },
            { isSelected: false, label: 'Inativo', value: 'inactive' },
        ];
        this.levels = [
            { isSelected: false, label: 'Administrador', value: 'admin' },
            { isSelected: false, label: 'Proprietário', value: 'owner' },
            { isSelected: false, label: 'Gerente', value: 'manager' },
            { isSelected: false, label: 'Coordenador', value: 'coordinator' },
            { isSelected: false, label: 'Prospector', value: 'prospector' },
        ];
    }
    selectStatus(status) {
        this.getSubUsers();
    }
    selectLevel(level) {
        this.getSubUsers();
    }
    onSearch(term) {
        this.getSubUsers();
    }
    async getSubUsers() {
        const filters = {
            roles: this.levels.filter(l => l.isSelected).map(l => l.value),
            statuses: this.statuses.filter(l => l.isSelected).map(l => l.value),
            search: this.userSearchTerm,
        };
        const accountId = this.$store.getters['admin/get_selected_account'];
        await this.$store.dispatch('admin/fetch_sub_users', {
            accountId,
            ...filters,
        });
    }
};
FiltersContainer = __decorate([
    Component({
        components: {
            Input,
        },
    })
], FiltersContainer);
export default FiltersContainer;
